(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amoura-review-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amoura-review-slider')) {
    customElements.define('amoura-review-slider', class AmouraReviewSlider extends HTMLElement {
      connectedCallback() {
        this.destroy();
        this.rail = this.querySelector('[data-amoura-review-rail]');
        this.cards = Array.from(this.querySelectorAll('[data-amoura-review-card]'));
        if (!this.rail || !this.cards.length) return;
        this.range = this.querySelector('[data-amoura-review-range]');
        this.dots = Array.from(this.querySelectorAll('[data-amoura-review-dot]'));
        this.previousButton = this.querySelector('[data-amoura-review-previous]');
        this.nextButton = this.querySelector('[data-amoura-review-next]');
        this.abortController = new AbortController();
        this.signal = this.abortController.signal;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = 0;
        this.bindEvents();
        this.classList.add('is-ready');
        this.update();
      }

      disconnectedCallback() {
        this.destroy();
      }

      destroy() {
        if (this.abortController) this.abortController.abort();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.abortController = null;
        this.scrollFrame = null;
      }

      bindEvents() {
        const options = { signal: this.signal };
        this.rail.addEventListener('scroll', () => this.requestUpdate(), options);
        this.rail.addEventListener('pointerdown', (event) => this.onPointerDown(event), options);
        this.rail.addEventListener('pointermove', (event) => this.onPointerMove(event), options);
        this.rail.addEventListener('pointerup', (event) => this.onPointerUp(event), options);
        this.rail.addEventListener('pointercancel', () => this.endDrag(false), options);
        this.previousButton?.addEventListener('click', () => this.goTo(this.activeIndex - 1), options);
        this.nextButton?.addEventListener('click', () => this.goTo(this.activeIndex + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), options));
        this.addEventListener('keydown', (event) => this.onCarouselKeydown(event), options);
        this.range?.addEventListener('input', () => this.onRangeInput(), options);
        this.range?.addEventListener('change', () => this.snapToNearest(), options);
        this.range?.addEventListener('keydown', (event) => this.onRangeKeydown(event), options);
        window.addEventListener('resize', () => this.requestUpdate(), options);
        document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), options);
      }

      requestUpdate() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.update();
        });
      }

      getStep() {
        if (this.cards.length > 1) return this.cards[1].offsetLeft - this.cards[0].offsetLeft;
        return this.cards[0]?.getBoundingClientRect().width || 1;
      }

      getMaxScroll() {
        return Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
      }

      update() {
        const step = this.getStep();
        this.activeIndex = Math.max(0, Math.min(this.cards.length - 1, Math.round(this.rail.scrollLeft / Math.max(step, 1))));
        const maxScroll = this.getMaxScroll();
        if (this.range) {
          const progress = maxScroll > 0 ? this.rail.scrollLeft / maxScroll : 0;
          this.range.value = String(Math.round(progress * 1000));
          this.range.disabled = maxScroll === 0;
          this.range.setAttribute('aria-valuetext', `Review ${this.activeIndex + 1} of ${this.cards.length}`);
        }
        this.dots.forEach((dot, index) => {
          if (index === this.activeIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (this.previousButton) this.previousButton.disabled = this.rail.scrollLeft <= 1;
        if (this.nextButton) this.nextButton.disabled = this.rail.scrollLeft >= maxScroll - 1;
      }

      goTo(index, behavior) {
        const targetIndex = Math.max(0, Math.min(this.cards.length - 1, index));
        const motion = behavior || (this.reduceMotion.matches ? 'auto' : 'smooth');
        this.rail.scrollTo({ left: this.cards[targetIndex].offsetLeft - this.cards[0].offsetLeft, behavior: motion });
        this.activeIndex = targetIndex;
        this.update();
      }

      snapToNearest() {
        const step = this.getStep();
        this.goTo(Math.round(this.rail.scrollLeft / Math.max(step, 1)));
      }

      onPointerDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.dragState = { pointerId: event.pointerId, startX: event.clientX, startScroll: this.rail.scrollLeft };
        this.classList.add('is-dragging');
        this.rail.setPointerCapture(event.pointerId);
      }

      onPointerMove(event) {
        if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;
        this.rail.scrollLeft = this.dragState.startScroll - (event.clientX - this.dragState.startX);
      }

      onPointerUp(event) {
        if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;
        this.endDrag(true);
      }

      endDrag(shouldSnap) {
        if (this.dragState && this.rail.hasPointerCapture(this.dragState.pointerId)) this.rail.releasePointerCapture(this.dragState.pointerId);
        this.dragState = null;
        this.classList.remove('is-dragging');
        if (shouldSnap) this.snapToNearest();
      }

      onRangeInput() {
        const maxScroll = this.getMaxScroll();
        this.rail.scrollLeft = maxScroll * (Number(this.range.value) / 1000);
        this.update();
      }

      onCarouselKeydown(event) {
        if (event.target !== this && event.target !== this.rail) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.activeIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.activeIndex + 1);
        }
      }

      onRangeKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.activeIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.activeIndex + 1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          this.goTo(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          this.goTo(this.cards.length - 1);
        }
      }

      onBlockSelect(event) {
        const card = event.target?.closest?.('[data-amoura-review-card]');
        if (!card || !this.contains(card)) return;
        const index = this.cards.indexOf(card);
        if (index >= 0) this.goTo(index, 'auto');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amoura-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amoura-video-carousel')) {
    customElements.define('amoura-video-carousel', class AmouraVideoCarousel extends HTMLElement {
      connectedCallback() {
        this.destroy();
        this.cards = Array.from(this.querySelectorAll('[data-amoura-card]'));
        if (!this.cards.length) return;

        this.abortController = new AbortController();
        this.signal = this.abortController.signal;
        this.activeIndex = 0;
        this.inView = false;
        this.manualPaused = false;
        this.editorSelection = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.viewport = this.querySelector('[data-amoura-viewport]');
        this.stage = this.querySelector('[data-amoura-stage]');
        this.dots = Array.from(this.querySelectorAll('[data-amoura-dot]'));

        this.prepareVideos();
        this.bindEvents();
        this.applyState();
        this.classList.add('is-ready');
        this.observeVisibility();
      }

      disconnectedCallback() {
        this.destroy();
      }

      destroy() {
        if (this.observer) this.observer.disconnect();
        if (this.abortController) this.abortController.abort();
        if (this.reduceMotion && this.onMotionChange) this.reduceMotion.removeEventListener('change', this.onMotionChange);
        if (this.cards) this.cards.forEach((card) => this.pauseVideo(card.querySelector('video'), false));
        this.observer = null;
      }

      prepareVideos() {
        this.cards.forEach((card, index) => {
          const video = card.querySelector('video');
          if (!video) return;
          video.autoplay = false;
          video.removeAttribute('autoplay');
          video.controls = false;
          video.loop = true;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.preload = index === this.activeIndex ? 'metadata' : 'none';
          video.tabIndex = -1;
          video.setAttribute('aria-hidden', 'true');
        });
      }

      bindEvents() {
        const options = { signal: this.signal };
        this.querySelector('[data-amoura-previous]')?.addEventListener('click', () => this.previous(), options);
        this.querySelector('[data-amoura-next]')?.addEventListener('click', () => this.next(), options);

        this.cards.forEach((card, index) => {
          card.querySelector('[data-amoura-select]')?.addEventListener('click', () => this.selectFromCard(index), options);
          card.querySelector('[data-amoura-play-toggle]')?.addEventListener('click', (event) => {
            event.stopPropagation();
            this.togglePlayback(index);
          }, options);

          const video = card.querySelector('video');
          if (!video) return;
          video.addEventListener('play', () => {
            if (index !== this.activeIndex) {
              this.pauseVideo(video, true);
              return;
            }
            card.classList.add('is-video-playing');
            this.updatePlayControl();
          }, options);
          video.addEventListener('pause', () => {
            card.classList.remove('is-video-playing');
            this.updatePlayControl();
          }, options);
        });

        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), options));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.previous();
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.next();
          } else if ((event.key === ' ' || event.key === 'Enter') && event.target === this) {
            event.preventDefault();
            this.togglePlayback(this.activeIndex);
          }
        }, options);

        if (this.viewport) {
          this.viewport.addEventListener('pointerdown', (event) => this.onPointerDown(event), options);
          this.viewport.addEventListener('pointermove', (event) => this.onPointerMove(event), options);
          this.viewport.addEventListener('pointerup', (event) => this.onPointerUp(event), options);
          this.viewport.addEventListener('pointercancel', () => this.resetDrag(), options);
        }

        document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), options);
        document.addEventListener('shopify:block:deselect', (event) => this.onBlockDeselect(event), options);
        document.addEventListener('visibilitychange', () => this.onDocumentVisibility(), options);

        this.onMotionChange = () => {
          if (this.reduceMotion.matches) {
            this.cards.forEach((card) => this.pauseVideo(card.querySelector('video'), false));
          } else if (this.inView && !this.manualPaused && !this.editorSelection) {
            this.playActive(false);
          }
        };
        this.reduceMotion.addEventListener('change', this.onMotionChange);
      }

      observeVisibility() {
        if (!('IntersectionObserver' in window)) {
          this.inView = true;
          if (!this.reduceMotion.matches) this.playActive(false);
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          const wasInView = this.inView;
          this.inView = Boolean(entry?.isIntersecting && entry.intersectionRatio >= 0.45);
          if (!this.inView) {
            this.cards.forEach((card) => this.pauseVideo(card.querySelector('video'), false));
          } else if (!wasInView && !this.reduceMotion.matches && !this.manualPaused && !this.editorSelection && !document.hidden) {
            this.playActive(false);
          }
        }, { threshold: [0, 0.45, 1] });
        this.observer.observe(this);
      }

      previous() {
        this.setActive(this.activeIndex - 1, 'previous');
      }

      next() {
        this.setActive(this.activeIndex + 1, 'next');
      }

      goTo(index) {
        if (index === this.activeIndex) return;
        const nextIndex = (this.activeIndex + 1) % this.cards.length;
        this.setActive(index, index === nextIndex ? 'next' : 'previous');
      }

      selectFromCard(index) {
        if (index === this.activeIndex) return;
        const nextIndex = (this.activeIndex + 1) % this.cards.length;
        this.setActive(index, index === nextIndex ? 'next' : 'previous');
      }

      setActive(index, direction, shouldPlay = true) {
        const count = this.cards.length;
        if (!count) return;
        const previousActive = this.activeIndex;
        const wrappedIndex = direction === 'next'
          ? (previousActive - 1 + count) % count
          : direction === 'previous'
            ? (previousActive + 1) % count
            : -1;

        this.cards.forEach((card, cardIndex) => this.pauseVideo(card.querySelector('video'), cardIndex === previousActive));
        this.activeIndex = (index % count + count) % count;
        this.manualPaused = false;

        if (wrappedIndex >= 0 && wrappedIndex !== this.activeIndex) this.cards[wrappedIndex]?.classList.add('is-wrapping');
        this.applyState();
        if (wrappedIndex >= 0) {
          requestAnimationFrame(() => requestAnimationFrame(() => this.cards[wrappedIndex]?.classList.remove('is-wrapping')));
        }

        if (shouldPlay && this.inView && !this.reduceMotion.matches && !this.editorSelection && !document.hidden) this.playActive(false);
      }

      applyState() {
        const count = this.cards.length;
        const previousIndex = (this.activeIndex - 1 + count) % count;
        const nextIndex = (this.activeIndex + 1) % count;

        this.cards.forEach((card, index) => {
          const active = index === this.activeIndex;
          card.classList.toggle('is-active', active);
          card.classList.toggle('is-prev', count > 1 && index === previousIndex);
          card.classList.toggle('is-next', count > 1 && index === nextIndex);
          card.setAttribute('aria-current', active ? 'true' : 'false');
          const select = card.querySelector('[data-amoura-select]');
          if (select) select.tabIndex = active ? -1 : 0;
          const toggle = card.querySelector('[data-amoura-play-toggle]');
          if (toggle) toggle.hidden = !active || !card.querySelector('video');
          const video = card.querySelector('video');
          if (video) video.preload = active ? 'metadata' : 'none';
        });

        this.dots.forEach((dot, index) => {
          if (index === this.activeIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.updateActiveCopy();
        this.updatePlayControl();
      }

      updateActiveCopy() {
        const card = this.cards[this.activeIndex];
        if (!card) return;
        const mappings = [
          ['[data-amoura-source-step]', '[data-amoura-active-step]'],
          ['[data-amoura-source-title]', '[data-amoura-active-title]'],
          ['[data-amoura-source-caption]', '[data-amoura-active-caption]']
        ];
        mappings.forEach(([sourceSelector, targetSelector]) => {
          const source = card.querySelector(sourceSelector);
          const target = this.querySelector(targetSelector);
          if (!target) return;
          target.textContent = source?.textContent?.trim() || '';
          target.hidden = !target.textContent;
        });
      }

      togglePlayback(index) {
        if (index !== this.activeIndex) {
          this.setActive(index, null, false);
          return;
        }
        const video = this.cards[this.activeIndex]?.querySelector('video');
        if (!video) return;
        if (!video.paused) {
          this.manualPaused = true;
          this.pauseVideo(video, false);
        } else {
          this.manualPaused = false;
          this.playActive(true);
        }
      }

      playActive(manual) {
        const card = this.cards[this.activeIndex];
        const video = card?.querySelector('video');
        if (!video || (!manual && (!this.inView || this.reduceMotion.matches || this.manualPaused || document.hidden))) return;
        this.cards.forEach((otherCard, index) => {
          if (index !== this.activeIndex) this.pauseVideo(otherCard.querySelector('video'), true);
        });
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            card.classList.remove('is-video-playing');
            this.updatePlayControl();
          });
        }
      }

      pauseVideo(video, reset) {
        if (!video) return;
        video.pause();
        if (reset) {
          try { video.currentTime = 0; } catch (_) {}
          video.closest('[data-amoura-card]')?.classList.remove('is-video-playing');
        }
      }

      updatePlayControl() {
        const card = this.cards?.[this.activeIndex];
        const video = card?.querySelector('video');
        const button = card?.querySelector('[data-amoura-play-toggle]');
        if (!button || !video) return;
        const label = card.getAttribute('aria-label') || 'video';
        button.setAttribute('aria-label', `${video.paused ? 'Play' : 'Pause'} ${label}`);
      }

      onDocumentVisibility() {
        if (document.hidden) {
          this.cards.forEach((card) => this.pauseVideo(card.querySelector('video'), false));
        } else if (this.inView && !this.reduceMotion.matches && !this.manualPaused && !this.editorSelection) {
          this.playActive(false);
        }
      }

      onBlockSelect(event) {
        const card = event.target?.closest?.('[data-amoura-card]');
        if (!card || !this.contains(card)) return;
        const index = this.cards.indexOf(card);
        if (index < 0) return;
        this.editorSelection = true;
        this.setActive(index, null, false);
        this.editorSelection = true;
        this.cards.forEach((item) => this.pauseVideo(item.querySelector('video'), item !== card));
      }

      onBlockDeselect(event) {
        const card = event.target?.closest?.('[data-amoura-card]');
        if (!card || !this.contains(card)) return;
        this.editorSelection = false;
        if (this.inView && !this.reduceMotion.matches && !this.manualPaused) this.playActive(false);
      }

      onPointerDown(event) {
        if (event.pointerType === 'mouse' || event.button !== 0) return;
        this.dragStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }

      onPointerMove(event) {
        if (!this.dragStart || event.pointerId !== this.dragStart.id) return;
        const dx = event.clientX - this.dragStart.x;
        const dy = event.clientY - this.dragStart.y;
        if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) {
          this.resetDrag();
          return;
        }
        if (Math.abs(dx) < 8) return;
        this.classList.add('is-dragging');
        this.style.setProperty('--amoura-video-drag-x', `${Math.max(-90, Math.min(90, dx))}px`);
      }

      onPointerUp(event) {
        if (!this.dragStart || event.pointerId !== this.dragStart.id) return;
        const dx = event.clientX - this.dragStart.x;
        const dy = event.clientY - this.dragStart.y;
        this.resetDrag();
        if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
        if (dx < 0) this.next();
        else this.previous();
      }

      resetDrag() {
        this.dragStart = null;
        this.classList.remove('is-dragging');
        this.style.removeProperty('--amoura-video-drag-x');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
